export type Styling = {
  backgroundColor: string;
  badgeBackgroundColor: string;
  badgeTextColor: string;
  borderColor: string;
  status: string;
};
const SkillCard = ({
  skill,
  label,
  colorCodeData
}: {
  skill: any;
  label: string;
  colorCodeData: Styling;
}) => {
  return (
    <div
      style={{
        backgroundColor: colorCodeData.backgroundColor,
        borderColor: colorCodeData.borderColor
      }}
      className={
        'flex min-h-[120px] flex-col justify-between rounded-xl border-2 p-3 transition-all duration-300 hover:-translate-y-1 hover:transform hover:shadow-lg md:min-h-[140px] md:p-6'
      }
    >
      <div className='flex h-full flex-col justify-center text-center md:justify-between'>
        <h3 className='text-sm font-semibold leading-tight text-gray-800 sm:text-base'>
          {label}
        </h3>
        <span
          style={{
            backgroundColor: colorCodeData.badgeBackgroundColor,
            color: colorCodeData.badgeTextColor
          }}
          className={
            'mt-3 rounded-full px-3 py-1 text-xs font-medium sm:text-sm'
          }
        >
          {skill}
        </span>
      </div>
    </div>
  );
};
export default SkillCard;
